import { computed, Injectable, Signal, signal } from '@angular/core';
import { TableUISortModel } from '../models/table-sort.model';

@Injectable()
export class TableSortUIService {
  private _config = signal<Partial<TableUISortModel> | null>(null);
  public config: Signal<Partial<TableUISortModel> | null> = this._config.asReadonly();

  private _sortOrder = signal<TableUISortModel | null>(null);
  public order: Signal<TableUISortModel | null> = this._sortOrder.asReadonly();

  /**
   * The sort a header click continues from: the last click until the host passes its sort back,
   * then the host's. A table created over a sort restored from the store or the URL has had no
   * click yet, and continuing from nothing would send that same sort again — which the store
   * reads as "clicked twice" and clears.
   */
  public readonly current = computed(() => this._sortOrder() ?? this._config());

  public setConfig(config: Partial<TableUISortModel>): void {
    this._config.set(config);
    this._sortOrder.set(null);
  }

  public setSortOrder(sortOrder: TableUISortModel): void {
    this._sortOrder.set(sortOrder);
  }
}
